import GlobalLoading from "./global-loading.vue";

const promise = new Promise(resolve => {
  vueApp.component('global-loading', GlobalLoading);
  resolve();
});

window.pendingComponentLoads.push(promise);